module.exports = __webpack_public_path__ + "static/media/Odysseus.4cee968d.jpg";